import { UI_LABELS_JSON, fetchPlatformResources } from "@limitless/common/apis/resource-api";
import { ClientContext, log as pilog } from "@limitless/common/utils";
import { MESSAGE_RESOURCES, REASON_CODE_JSON, TAGS_JSON } from "../utils/MessageResourceUtil";
export const INITIAL_MESSAGE_RESOURCES = {
  reasonCodes: {
    codes: {
      response: [],
      escalation: [{
        code: "CUSC01",
        description: "Customer complaint - not a question, customer is dissatisfied"
      }, {
        code: "CUSR01",
        description: "Customer request - forward question back to the contact centre"
      }, {
        code: "SCON01",
        description: "Sensitive content - medical or delicate information request"
      }, {
        code: "PRES01",
        description: "Press enquiry - not a question"
      }, {
        code: "OTHE01",
        description: "Other reason"
      }],
      report: [{
        code: "INCO01",
        description: "Inappropriate content – should not answer because of content"
      }, {
        code: "OTHE01",
        description: "Other"
      }]
    }
  },
  tags: [],
  messageId: null
};
let MESSAGE_RESOURCE_CACHE = {};
const ORIGINAL_LABELS_KEY = "original-labels";
const getPlatformResourceOptions = (message, profile, useProfileLocale) => {
  let locale = `${profile.language}-${profile.country}`;
  //if the message has these props set, use them instead
  if (!useProfileLocale && message.language && message.country) {
    locale = `${message.language}-${message.country}`;
  }
  const tenant = message.tenantName ? message.tenantName : "";
  const group = message.groupName ? message.groupName : "";
  return {
    tenant,
    group,
    locale,
    cacheKey: `${locale}-${tenant}-${group}`
  };
};
export const findMessageResources = (profile, message, currentMessageResources, options = {}, callback) => {
  var _currentMessageResour, _currentMessageResour2, _currentMessageResour3;
  const log = pilog.getLogger("MessageResourceAction loadMessageResources");
  const {
    appName = ClientContext._appName,
    blackListResources = [],
    useProfileLocale = false
  } = options;
  log.debug(currentMessageResources);
  const isReasonCodes = ((_currentMessageResour = currentMessageResources.reasonCodes) === null || _currentMessageResour === void 0 ? void 0 : (_currentMessageResour2 = _currentMessageResour.codes) === null || _currentMessageResour2 === void 0 ? void 0 : (_currentMessageResour3 = _currentMessageResour2.response) === null || _currentMessageResour3 === void 0 ? void 0 : _currentMessageResour3.length) > 0;
  if (currentMessageResources.messageId && message.messageId === currentMessageResources.messageId && isReasonCodes) {
    log.debug("Resources already loaded for this message, skipping platform call");
    callback(message, currentMessageResources);
  } else {
    const {
      tenant,
      group,
      locale,
      cacheKey
    } = getPlatformResourceOptions(message, profile, useProfileLocale);
    const cachedResponse = MESSAGE_RESOURCE_CACHE[cacheKey];
    if (cachedResponse && isReasonCodes) {
      log.debug(`Cache hit for ${cacheKey}`);
      processPlatformResources(cachedResponse, message, currentMessageResources, callback);
    } else {
      const resources = MESSAGE_RESOURCES.filter(resource => {
        return !blackListResources.includes(resource);
      });
      //fetch message codes and tags
      fetchPlatformResources({
        ignoreCache: true,
        applicationName: appName,
        resourceList: resources,
        locale,
        groupName: group,
        tenantName: tenant,
        tenantGroupOnly: true
      }, response => {
        log.debug(`Storing ${cacheKey} resources in cache`);
        MESSAGE_RESOURCE_CACHE[cacheKey] = response;
        processPlatformResources(response, message, currentMessageResources, callback);
      });
    }
  }
};
const processPlatformResources = (platformResources, message, currentMessageResources, callback) => {
  const {
    messageResources,
    messageLabels
  } = processMessageResources(platformResources);
  messageResources.messageId = message.messageId;
  callback(message, messageResources, messageLabels);
};
export const cacheUILabels = uilabels => {
  if (uilabels) {
    MESSAGE_RESOURCE_CACHE[ORIGINAL_LABELS_KEY] = {
      resourceName: UI_LABELS_JSON.name,
      content: uilabels
    };
  }
};
export const processMessageResources = platformResources => {
  const log = pilog.getLogger("MessageResourceAction processMessageResources");
  let errorMessage = "";
  const messageResources = {
    ...INITIAL_MESSAGE_RESOURCES
  };
  log.debug(MESSAGE_RESOURCE_CACHE);
  const messageLabels = {
    original: MESSAGE_RESOURCE_CACHE[ORIGINAL_LABELS_KEY],
    message: null
  };
  //handle each resource in a scalable manner.
  platformResources.map(resource => {
    switch (resource.resourceName) {
      case REASON_CODE_JSON.name:
        if (resource.content) {
          try {
            // Checking if Report/Escalate property is missing from JSON
            const reasonCode = resource.content;
            reasonCode.codes.report = reasonCode.codes.report || INITIAL_MESSAGE_RESOURCES.codes.report;
            reasonCode.codes.escalation = reasonCode.codes.escalation || INITIAL_MESSAGE_RESOURCES.codes.escalation;
            messageResources.reasonCodes = reasonCode;
          } catch (error) {
            errorMessage = `Invalid JSON for ${REASON_CODE_JSON.name}, no reason codes will be used`;
            log.error(errorMessage, error);
          }
        }
        break;
      case TAGS_JSON.name:
        log.debug("TAGS_JSON: ", resource);
        if (resource.content) {
          try {
            messageResources.tags = resource.content.response;
          } catch (error) {
            errorMessage = `Invalid JSON for ${TAGS_JSON.name}, no tags will be used`;
            log.error(errorMessage, error);
            messageResources.tags = [];
          }
        } else {
          log.debug("There are no tags for this message");
          messageResources.tags = [];
        }
        break;
      case UI_LABELS_JSON.name:
        log.debug("UI_LABELS_JSON: ", resource);
        if (resource.content && Object.keys(resource.content).length !== 0) {
          messageLabels.message = resource.content;
        } else {
          log.debug("There is no specific content for this message, so resetting labels to the users original labels");
        }
        break;
      default:
        log.warn("Unidentified resource returned from platform");
    }
  });
  if (errorMessage) {
    messageResources.error = errorMessage;
  }
  log.debug("Processed resources ", messageResources);
  return {
    messageResources,
    messageLabels
  };
};
export const processMessageResourceCache = params => {
  const {
    locale,
    tenantName,
    groupName
  } = params;
  if (locale !== "" && tenantName !== "" && groupName !== "") {
    removeMessageResourceCacheItem(`${locale}-${tenantName}-${groupName}`);
  } else {
    clearMessageResourceCache();
  }
};
export const clearMessageResourceCache = () => {
  if (MESSAGE_RESOURCE_CACHE[ORIGINAL_LABELS_KEY]) {
    MESSAGE_RESOURCE_CACHE = {
      [ORIGINAL_LABELS_KEY]: MESSAGE_RESOURCE_CACHE[ORIGINAL_LABELS_KEY]
    };
  } else {
    MESSAGE_RESOURCE_CACHE = {};
  }
};
export const removeMessageResourceCacheItem = cacheKey => {
  Reflect.deleteProperty(MESSAGE_RESOURCE_CACHE, cacheKey);
};
export const clearMessageResourceCacheItem = (message, profile) => {
  const {
    cacheKey
  } = getPlatformResourceOptions(message, profile);
  removeMessageResourceCacheItem(cacheKey);
};